import Ajax from '../../../../common/js/Ajax.js';
import ButtonUtils from '../../../../common/js/ButtonUtils.js';
import Form from '../../../../common/js/form/Form.js';
import LangUtils from '../../../../common/js/LangUtils.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import Widget from '../../../../common/js/Widget.js';

import DE_LOAD_FAILED_TEMPLATE from './IssuesWidget-load-failed-de.hbs';
import DE_SEARCH_TEMPLATE from './IssuesWidget-search-de.hbs';
import DE_ISSUES_TEMPLATE from './IssuesWidget-issues-de.hbs';

import EN_LOAD_FAILED_TEMPLATE from './IssuesWidget-load-failed-en.hbs';
import EN_SEARCH_TEMPLATE from './IssuesWidget-search-en.hbs';
import EN_ISSUES_TEMPLATE from './IssuesWidget-issues-en.hbs';


export default class IssuesWidget extends Widget {

	constructor($widget) {
		super($widget);
		this.spinner();
		Ajax.rpc('/projects', result => {
			this.admin = result.admin;

			try {
				result.prev = JSON.parse(sessionStorage['lastSearch']);
			} catch (error) {
				// Ignored
			}
			this.$widget.html(LangUtils.isGerman()
				? DE_SEARCH_TEMPLATE(result) : EN_SEARCH_TEMPLATE(result));
			this.show();

			this.$result = $('.js_result');
			this.$widget.find('select').change(() => {
				this.search();
			});
			this.$widget.find('input[name="term"]').keydown(event => {
				if (event.which == 13) {
					this.search();
				}
			});

			if (this.admin || result.prev.project || result.prev.term || result.prev.status) {
				this.search();
			}
		}, error => {
			this.show();
			MessageUtils.error($widget, LangUtils.isGerman()
				? DE_LOAD_FAILED_TEMPLATE() : EN_LOAD_FAILED_TEMPLATE(), error);
		});
	}

	search() {
		var $button = this.$widget.find('.js_search');
		ButtonUtils.setState($button, 'none');

		if (Form.validate(this.$widget).length) {
			return;
		}

		var data = {
			project: this.$widget.find('[name="project"]').val(),
			status: this.$widget.find('[name="status"]').val(),
			term: this.$widget.find('[name="term"]').val().trim()
		};

		ButtonUtils.setState($button, 'active');
		this.spinner(this.$result);
		Ajax.rpc('/searchIssues', data, issues => {
			var ids = $.map(issues, issue => {return issue.id;});
			if (ids.length <= 100)
				data.ids = ids;
			sessionStorage['lastSearch'] = JSON.stringify(data);

			this.$result.html((LangUtils.isGerman() ? DE_ISSUES_TEMPLATE : EN_ISSUES_TEMPLATE)
				({issues, admin: this.admin}));
			ButtonUtils.setState($button, 'none');

			this.$widget.find('.js_issue').click(event => {
				var issueId = $(event.currentTarget).attr('data-id');
				if (LangUtils.isGerman()) {
					window.location.href = '/de/thema?id=' + issueId;
				} else {
					window.location.href = '/en/issue?id=' + issueId;
				}
			});
		}, error => {
			ButtonUtils.setState($button, 'none');
			MessageUtils.error(this.$result, 'Failed to load issues', error);
		});
	}

}
